import React from "react";
import "../../assets/scss/intel.scss";
import "../../assets/scss/global.scss";
export default class NoSearchDataComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={`${this.props.className} no-search-data-container`}>
        <p className="no-search-data-box">{this.props.content}</p>
      </div>
    );
  }
}
